import { connect } from "react-redux"
import React, { Component } from 'react';
import './Common.css';
import './ProposeBet.css';
import { changeTextInput, changePageContext, updateEthPrice, createBetProposal, viewProposalLoadAndNav } from "../actions/betActions"
import moment from 'moment-timezone';
import DatePickerInput from './DatePickerInput';
import TextCurrencyInput from './TextCurrencyInput';
import 'react-datepicker/dist/react-datepicker.css';
import UsernameInput from './UsernameInput';

const stateMap = (store) => {
    return {
        textInputData: store.bet.textInputData,
        pageContext: store.bet.pageContext,
        authentication: store.bet.authentication,
        ethPrice: store.bet.ethPrice
    };
};
class ProposeBet extends Component {
    constructor(props) {
      super(props);

        // This binding is necessary to make `this` work in the callback
        this.changeTextInput = this.changeTextInput.bind(this);
        this.clearTextInput = this.clearTextInput.bind(this);
        this.viewProposal = this.viewProposal.bind(this);
        this.getContext = this.getContext.bind(this);
        this.nextStep = this.nextStep.bind(this);
        this.prevStep = this.prevStep.bind(this);
        this.allowNextStep = this.allowNextStep.bind(this);
        this.allowPrevStep = this.allowPrevStep.bind(this);
        this.showDone = this.showDone.bind(this);
        this.navigateToBet = this.navigateToBet.bind(this);
        this.showHoverHelp = this.showHoverHelp.bind(this);
        this.hideHoverHelp = this.hideHoverHelp.bind(this);
        this.isValidDate = this.isValidDate.bind(this);
        this.isValidFloat = this.isValidFloat.bind(this);
        this.convertEthToUsd = this.convertEthToUsd.bind(this);
        this.createBetProposal = this.createBetProposal.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.inputDateIsValid = this.inputDateIsValid.bind(this);
    }

    componentDidMount() {
        this.props.dispatch(updateEthPrice());
    }

    getContext() {
        let { PROPOSE_BET_CONTEXT={} } = this.props.pageContext;
        let { step="OPPONENT", hover_betExpiresDate=false, hover_arbitrationRequestDate=false, hover_daysBeforeDefaultJudgement=false, valid_daysBeforeDefaultJudgement=true, usd_amount1="", usd_amount2="", usd_arbitrationFee="", createBetStarted=false, createBetFailed=false, keyProposal="", keyVersion="", keyParticiant1="" } = PROPOSE_BET_CONTEXT;

        return { step, hover_betExpiresDate, hover_arbitrationRequestDate, hover_daysBeforeDefaultJudgement, valid_daysBeforeDefaultJudgement, usd_amount1, usd_amount2, usd_arbitrationFee, createBetStarted, createBetFailed, keyProposal, keyVersion, keyParticiant1 };
    }

    handleDateChange(name, value) {
        this.props.dispatch(changeTextInput(name, value, "PROPOSE_BET"));
    }

    changeTextInput(event) {

        let name = event.target.name;
        let value = event.target.value;
        let filter = "";
        let filterDots = false;

        if(name === "participant2") { filter = /[^a-zA-Z0-9_]/gi; }
        if(name === "amount1") { filter = /[^0-9.]/gi; filterDots = true; }
        if(name === "amount2") { filter = /[^0-9.]/gi; filterDots = true; }
        if(name === "arbiter") { filter = /[^a-zA-Z0-9_]/gi; }
        if(name === "arbitrationFee") { filter = /[^0-9.]/gi; filterDots = true; }
        if(name === "daysBeforeDefaultJudgement") { filter = /[^0-9]/gi; }

        value = value.replace(filter, "");
        if(filterDots) {
            value = value.replace(/\.(\.)+/gi, ".");
            if(value.length > 0 && value[0] === '.') {
                value = "0" + value;
            }

            if(value.length > 10) {
                value = value.substring(0, 10);
            }
        }

        this.props.dispatch(changeTextInput(name, value, "PROPOSE_BET"));

        if(name === "amount1" || name === "amount2" || name === "arbitrationFee") {
            this.props.dispatch(updateEthPrice());
        }
    }

    inputDateIsValid(str) {
        const date = this.getDateFromString(str);
        return str === "" || date !== null;
    }

    clearTextInput(event) {
        let name = event.target.getAttribute("clear");
        this.refs["datePicker_" + name].setOpen(false);
        this.props.dispatch(changeTextInput(name, "", "PROPOSE_BET"));
    }

    viewProposal(event) {

    }

    createBetProposal(event) {
        let { PROPOSE_BET={} } = this.props.textInputData;
        let { participant2="", amount1="", amount2="", betText="", arbiter="", arbitrationFee="", betExpiresDate="", arbitrationRequestDate="", daysBeforeDefaultJudgement="30" } = PROPOSE_BET;

        this.props.dispatch(createBetProposal(this.props.authentication.uuid, participant2, betText, amount1, amount2, arbiter, arbitrationFee, betExpiresDate, arbitrationRequestDate, daysBeforeDefaultJudgement));
    }

    convertEthToUsd(value) {

      let ethPrice = this.props.ethPrice;

      let usdStr = "";
      if(value !== "" && value !== null && /^[0-9]+\.?[0-9]*?$/i.test(value) && ethPrice && ethPrice.hasOwnProperty("USD")) {

        let usdPerEth = ethPrice.USD;
        let usdFloat = parseFloat(value) * usdPerEth;

        if(!isNaN(usdFloat)) {
          usdStr = "$" + usdFloat.toLocaleString('en', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + " USD";
        }
      }
      
      return usdStr;
    }

    navigateToBet() {
        let context = this.getContext();
        this.props.dispatch(viewProposalLoadAndNav(context.keyParticiant1, context.keyProposal));
    }

    getDateFromString(str) {
        if(str === "") { return null; }

        if(/^[0-9][0-9]\/[0-9][0-9]\/[0-9][0-9][0-9][0-9]$/.test(str)) {
            let date = moment(str, "MM/DD/YYYY");
            if(date.isValid() && this.isValidDate(date)) {
                return date;
            }
        }

        return null;
    }

    isValidDate(date) {
        return date.diff(moment().tz('America/Los_Angeles'), 'days') >= 0;
    }

    nextStep() {
        let context = this.getContext();

        let nextStep = "OPPONENT";
        if(context.step === "OPPONENT") { nextStep = "BET_AMOUNT"; }
        else if(context.step === "BET_AMOUNT") { nextStep = "BET_TERMS"; }
        else if(context.step === "BET_TERMS") { nextStep = "ARBITER"; }
        else if(context.step === "ARBITER") { nextStep = "RULES_FOR_RESOLUTION"; }
        else if(context.step === "RULES_FOR_RESOLUTION") { nextStep = "SUCCESS"; }

        this.props.dispatch(changePageContext({step: nextStep }, "PROPOSE_BET"));
    }

    prevStep() {
        let context = this.getContext();

        let prevStep = "OPPONENT";
        if(context.step === "SUCCESS") { prevStep = "RULES_FOR_RESOLUTION"; }
        else if(context.step === "RULES_FOR_RESOLUTION") { prevStep = "ARBITER"; }
        else if(context.step === "ARBITER") { prevStep = "BET_TERMS"; }
        else if(context.step === "BET_TERMS") { prevStep = "BET_AMOUNT"; }
        else if(context.step === "BET_AMOUNT") { prevStep = "OPPONENT"; }

        this.props.dispatch(changePageContext({step: prevStep }, "PROPOSE_BET"));
    }

    isValidFloat(str) {
        if(str && str !== "" && /^[0-9]+\.?[0-9]*?$/i.test(str)) {
            return true;
        }

        return false;
    }

    allowNextStep() {
        let context = this.getContext();

        let { PROPOSE_BET={} } = this.props.textInputData;
        let { participant2="", amount1="", amount2="", betText="", arbiter="", arbitrationFee="", daysBeforeDefaultJudgement="30", arbitrationRequestDate="", betExpiresDate="" } = PROPOSE_BET;

        if(context.step === "OPPONENT") {
            if(participant2 && participant2 !== "" && /^[a-zA-Z0-9_]+$/i.test(participant2)) {
                return true;
            }
            return false;
        }
        else if(context.step === "BET_AMOUNT") {
            if(this.isValidFloat(amount1) && this.isValidFloat(amount2)) {
                return true;
            }
            return false;
        }
        else if(context.step === "BET_TERMS") {
            if(betText && betText !== "") {
                return true;
            }
            return false;
        }
        else if(context.step === "ARBITER") {
            if(arbiter && arbiter !== "" && /^[a-zA-Z0-9_]+$/i.test(arbiter) && this.isValidFloat(arbitrationFee)) {
                return true;
            }
            return false;
        }
        else if(context.step === "RULES_FOR_RESOLUTION") {
            if(this.inputDateIsValid(arbitrationRequestDate) && this.inputDateIsValid(betExpiresDate) && daysBeforeDefaultJudgement && daysBeforeDefaultJudgement !== "" && /^[0-9]+$/i.test(daysBeforeDefaultJudgement) && context.createBetStarted === false) {
                return true;
            }
            return false;
        }

        return true;
    }

    allowPrevStep() {
        let context = this.getContext();
        if(context.step === "OPPONENT") {
            return false;
        }
        else if(context.step === "SUCCESS") {
            return false;
        }
        else if(context.step === "RULES_FOR_RESOLUTION" && context.createBetStarted) {
            return false;
        }

        return true;
    }

    showDone() {
        let context = this.getContext();
        if(context.step === "SUCCESS") {
            return true;
        }

        return false;
    }

    showCreateBet() {
        let context = this.getContext();
        if(context.step === "RULES_FOR_RESOLUTION") {
            return true;
        }

        return false;
    }

    showHoverHelp(event) {
        let name = event.target.getAttribute("name");
        console.log("showHoverHelp: " + name);
        this.props.dispatch(changePageContext({[name]: true}, "PROPOSE_BET"));
    }
    
    hideHoverHelp(event) {
        let name = event.target.getAttribute("name");
        console.log("hideHoverHelp: " + name);
        this.props.dispatch(changePageContext({[name]: false}, "PROPOSE_BET"));
    }

    render() {  

    let { PROPOSE_BET={} } = this.props.textInputData;
    let { participant2="", amount1="", amount2="", betText="", arbiter="", arbitrationFee="", betExpiresDate="", arbitrationRequestDate="", daysBeforeDefaultJudgement="30" } = PROPOSE_BET;
    let context = this.getContext();
    let { username=""} = this.props.authentication;

    let allowNextStep = this.allowNextStep();
    let allowPrevStep = this.allowPrevStep();
    let showDone = this.showDone();

      return (
          <div>
            <div className="dialog">

                {allowPrevStep ? (
                    <button className="btn posTopLeft" onClick={this.prevStep}>&larr;</button>
                ) : (
                    <button className="btn posTopLeft disabled">&larr;</button>
                )}
                
                {allowNextStep ? (showDone ? (
                    <button className="btn posTopRight" onClick={this.navigateToBet}>Done</button>
                ) : (this.showCreateBet() ? (
                    <button className="btn posTopRight" onClick={this.createBetProposal}>Create bet</button>
                ) : (
                    <button className="btn posTopRight" onClick={this.nextStep}>Next</button>
                ))) : (
                    <button className="btn posTopRight disabled">{showDone ? "Done" : this.showCreateBet() ? "Create bet" : "Next" }</button>
                )}
                
                <div className={context.step === "OPPONENT" ? "" : "hide"}>
                    <div className="padBottom"></div>
                    <div className="labelInputGroup moveTop40">Who are you making a bet with?</div>
                    <UsernameInput className="moveTop20" name="participant2" value={participant2} onChange={this.changeTextInput} />
                </div>
                <div className={context.step === "BET_AMOUNT" ? "" : "hide"}>
                    <div className="padBottom"></div>
                    <div className="labelInputGroup moveTop40">How much are you betting?</div>
                    <div><label className="labelInput moveTop20">@{username}</label></div>
                    <TextCurrencyInput 
                        className="textInput widthDialogInput" 
                        name="amount1" 
                        value={amount1}
                        onChange={this.changeTextInput}
                        ethPrice={this.props.ethPrice}
                        placeholder="Bet amount in ETH"
                        outerClassName=""
                        disabled={false} 
                    />
                    <div><label className="labelInput moveTop20">@{participant2}</label></div>
                    <TextCurrencyInput 
                        className="textInput widthDialogInput" 
                        name="amount2" 
                        value={amount2}
                        onChange={this.changeTextInput}
                        ethPrice={this.props.ethPrice}
                        placeholder="Bet amount in ETH"
                        outerClassName=""
                        disabled={false} 
                    />
                </div>
                <div className={context.step === "BET_TERMS" ? "" : "hide"}>
                    <div className="padBottom"></div>
                    <div className="labelInputGroup moveTop40 hide">Describe the terms of the bet</div>
                    <div className="labelInputGroup moveTop40 ">Describe the terms of the how and when the bet will be decided</div>
                    <div><textarea placeholder={"Be as specific as possible to explain when @" + username + " wins, when @" + participant2 + " wins and under what conditions (if any) there is a tie.  Make sure to refer to a specific date if appropriate."} className="textAreaInput widthDialogInput moveTop20" name="betText" value={betText} onChange={this.changeTextInput} /></div>
                </div>
                <div className={context.step === "ARBITER" ? "" : "hide"}>
                    <div className="padBottom"></div>
                    <div className="labelInputGroup moveTop40">Specify an arbiter in case of a dispute</div>
                    <UsernameInput className="moveTop20" name="arbiter" value={arbiter} onChange={this.changeTextInput} />
                    <TextCurrencyInput 
                        className="textInput widthDialogInput" 
                        name="arbitrationFee" 
                        value={arbitrationFee}
                        onChange={this.changeTextInput}
                        ethPrice={this.props.ethPrice}
                        placeholder="Arbitration fee in ETH"
                        outerClassName="moveTop20"
                        disabled={false} 
                        />
                    <div><label className="labelInput moveTop20">The arbiter is only paid if the bettors can't agree on the result.  To encourage honesty, the arbitration fee is paid by the bettor that disagrees with the arbiter.</label></div>
                </div>
                <div className={context.step === "RULES_FOR_RESOLUTION" ? "" : "hide"}>
                    <div className="padBottom"></div>
                    <div className="labelInputGroup moveTop40">Rules for arbitration and bet resolution</div>

                    <div><label style={{position: "relative"}} className="labelInput moveTop20">Bet expires and bettors get refunds<div name="hover_betExpiresDate" onMouseEnter={this.showHoverHelp} onMouseLeave={this.hideHoverHelp} className="questionCircle"></div></label></div>

                    <DatePickerInput 
                        onChange={this.handleDateChange}
                        className="textInput widthDialogInput" 
                        value={betExpiresDate} 
                        disabled={context.createBetStarted} 
                        hover={context.hover_betExpiresDate}
                        name="betExpiresDate"
                        blankText="Never"
                        hoverText="Date when bet will expire if you disagree with your opponent and the arbiter doesn't respond. This lets you get your money back if no decision can be reached."
                    />

                    <div><label style={{position: "relative"}} className="labelInput moveTop20">Bettors can request arbitration<div name="hover_arbitrationRequestDate" onMouseEnter={this.showHoverHelp} onMouseLeave={this.hideHoverHelp} className="questionCircle"></div></label></div>

                    <DatePickerInput 
                        onChange={this.handleDateChange}
                        className="textInput widthDialogInput" 
                        value={arbitrationRequestDate} 
                        disabled={context.createBetStarted} 
                        hover={context.hover_arbitrationRequestDate}
                        name="arbitrationRequestDate"
                        blankText="Any time"
                        hoverText='Date from which you and your opponent can request arbitration. If set to "Any time" then bettors can request arbitration any time after the bet is active.'
                    />

                    <div><label style={{position: "relative"}} className="labelInput moveTop20">Days to respond to arbitration before losing by default<div name="hover_daysBeforeDefaultJudgement" onMouseEnter={this.showHoverHelp} onMouseLeave={this.hideHoverHelp} className="questionCircle"></div></label></div>
                    
                    <div style={{position: "relative"}} className="">
                        <input disabled={context.createBetStarted} placeholder="Number of days" type="text" className={"textInput widthDialogInput" + (context.createBetStarted ? " disabled" : "")} name="daysBeforeDefaultJudgement" value={daysBeforeDefaultJudgement} onChange={this.changeTextInput} />
                        <div className={daysBeforeDefaultJudgement && daysBeforeDefaultJudgement !== "" && /^[0-9]+$/i.test(daysBeforeDefaultJudgement) ? "hide" : "inputError"}>Please enter number of days</div>
                        <div className={context.hover_daysBeforeDefaultJudgement ? "questionHoverHelp" : "questionHoverHelp hide"}>Before arbitration can occur both bettors need to post a bond equal to the arbitration fee. After someone requests arbitration their opponent has this many days to post a bond before they lose by default.</div>
                    </div>
                    
                </div>
                <div className={context.step === "SUCCESS" ? "" : "hide"}>
                    <div className="padBottom"></div>
                    <div className="labelInputGroup moveTop40">You've created a bet proposal!</div>

                    <div><label className="labelInput moveTop20">Invite @{participant2} and @{arbiter} to join the bet</label></div>
                    <div><a target="_blank" className="btn" href={"https://twitter.com/intent/tweet?text=%40" + participant2 + "%20I%20challenge%20you%20to%20a%20bet%20with%20%40" + arbiter + "%20as%20the%20arbiter.%20%20See%20here%20for%20details%3A%20https%3A%2F%2Fethbet.network%2Fbet%2F34343"}>Click to tweet</a></div>
                    <div><label className="labelInput moveTop20">View your bet proposal</label></div>
                    <div><button className="btn"  onClick={this.navigateToBet}>Click to view</button></div>
                    <div><label className="labelInput moveTop20">Once @{participant2} and @{arbiter} agree to the bet terms then you'll be asked to deposit funds.</label></div>

                    

                </div> 
            </div>
          </div>
      );
    }
  }
  
  export default connect(stateMap)(ProposeBet);



// WEBPACK FOOTER //
// ./src/components/ProposeBet.js